// typography.js

export const variants = {
	// 64px
	h1: {
		fontSize: '6rem',
		fontFamily: 'Inter',
	},
	// 48px
	h2: {
		fontSize: '5rem',
		fontFamily: 'Inter',
	},
	// 38px
	h3: {
		fontSize: '4rem',
		fontFamily: 'Inter',
	},
	// 32px
	h4: {
		fontSize: '2rem',
		fontFamily: 'Inter',
	},
	// 28px
	h5: {
		fontSize: '1.75rem',
		letterSpacing: '-0.02em',
		fontFamily: 'Inter',
	},
	// 24px
	h6: {
		fontSize: '1.5rem',
		fontFamily: 'Inter',
	},
	// 20px
	body1: {
		fontSize: '3rem',
		fontFamily: 'Inter',
	},
	// 18px
	subtitle1: {
		fontSize: '1.125rem',
		fontFamily: 'Inter',
	},
	// 16px
	subtitle2: {
		fontSize: '1rem',
		fontFamily: 'Inter',
	},
	// 16px
	body2: {
		fontSize: '1rem',
		fontFamily: 'Inter',
	},
	// 14px
	caption: {
		fontSize: '0.875rem',
		fontFamily: 'Inter',
	},
};

export const fontWeights = {
	regular: 400,
	medium: 600,
	bold: 700,
	heavy: 800,
};
